import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'GET', label: 'GET' },
			{ value: 'PUT', label: 'PUT' },
			{ value: 'POST', label: 'POST' },
			{ value: 'PATCH', label: 'PATCH' },
			{ value: 'DELETE', label: 'DELETE' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

